import { Box, BoxProps } from '@mui/material';

const StyledCard = ({ sx, ...rest }: BoxProps) => (
  <Box
    sx={{
      boxShadow: 'rgb(145 158 171 / 24%) 0px 0px 2px 0px, rgb(145 158 171 / 24%) -10px 10px 40px -4px',
      borderRadius: 1,
      overflow: 'hidden',
      background: (t) => t.palette.background.paper,
      cursor: 'pointer',
      ...sx,
    }}
    {...rest}
  />
);

export default StyledCard;
